export class FUIColorPair {
    backgroundColor: string;
    foregroundColor: string;
}
